export class PlayerHeadController {

    constructor() {
    }
}